import type { Tournament } from '@/core/domains/tournament/entity'

export const useBrickTournamentsStore = defineStore('brickTournaments', {
  actions: {
    getTournament(id: number) {
      return this.list.find((entry) => entry.id === id)
    },
    setTournamentFinished(id: number) {
      const index = this.list.findIndex((entry) => entry.id === id)
      if (this.list[index]) {
        this.list[index].active = false
        this.list[index].finished = true
        this.list[index].finish_date = Date.now() / 1000
      }
    },
    updateList(list: Tournament[]) {
      list.forEach((tournament) => {
        this.updateTournament(tournament)
      })
    },
    updateListPreview(list: Record<string, Tournament>) {
      Object.values(list).forEach((tournament) => {
        this.updateTournament(tournament)
      })
    },
    updateTournament(tournament: Tournament) {
      const index = this.list.findIndex((entry) => entry.id === tournament.id)
      if (index >= 0) {
        this.list[index] = { ...this.list[index], ...tournament }
      } else {
        this.list.push(tournament)
      }
    },
  },
  getters: {
    activeTournaments(): Tournament[] {
      const result = this.list.filter((value) => value.active)
      return result.sort((a, b) => Number(b.settings?.is_fast) - Number(a.settings?.is_fast))
    },
    hasActiveTournaments(): boolean {
      return this.activeTournaments.length > 0
    },
    lastTournament(): Tournament | undefined {
      const activeList = this.list.filter((value) => value.active || value.is_scheduled)
      if (!activeList.length) {
        return
      }
      return activeList.reduce((result, item) => {
        return result.start_date < item.start_date ? result : item
      })
    },
  },
  state: (): {
    list: Tournament[]
  } => ({
    list: [],
  }),
})
